import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.scss';

// Global initialization function
window.initGeoSearchReact = function(containerId, config) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('GeoSearch container not found:', containerId);
        return;
    }

    const root = createRoot(container);
    root.render(<App config={config} />);
};

// Auto-initialize if config is available
if (window.gwBpGeoSearchConfig) {
    Object.keys(window.gwBpGeoSearchConfig).forEach(instanceId => {
        const config = window.gwBpGeoSearchConfig[instanceId];
        window.initGeoSearchReact(instanceId, config);
    });
}
